<ng-container *ngFor="let group of groups; trackBy: trackByGroupName">
  <!-- The zone list sits between "Value & range" and the formatting groups. -->
  <div class="zss-group" *ngIf="group.name === 'Number format'">
    <button type="button" class="zss-group-head" [class.is-open]="isOpen('Zones')" (click)="toggle('Zones')">
      <mat-icon>{{ isOpen('Zones') ? 'expand_more' : 'chevron_right' }}</mat-icon>
      <span>Zones</span>
      <small>{{ zones().length }}</small>
    </button>

    <div class="zss-group-body" *ngIf="isOpen('Zones')">
      <p class="zss-hint is-note" *ngIf="zonesFromData()">
        Zones come from the dataset picked in the <b>Data</b> tab. This list is the fallback shown until those rows load.
      </p>

      <div class="zss-zone" *ngFor="let zone of zones(); let i = index; let first = first; let last = last; trackBy: trackByIndex">
        <input
          type="color"
          class="zss-zone-color"
          [value]="zoneColor(zone, i)"
          (input)="setZone(i, { color: $any($event.target).value })"
          matTooltip="Zone colour"
          [attr.aria-label]="'Colour of zone ' + (i + 1)"
        />
        <input
          type="text"
          class="zss-zone-label"
          [value]="zone.label ?? ''"
          placeholder="Label"
          (input)="setZone(i, { label: $any($event.target).value })"
          [attr.aria-label]="'Label of zone ' + (i + 1)"
        />
        <input
          type="number"
          class="zss-zone-to"
          [value]="zone.to ?? ''"
          [placeholder]="last ? 'max' : 'to'"
          (input)="setZoneTo(i, $any($event.target).value)"
          matTooltip="Upper bound (empty = up to the next zone / maximum)"
          [attr.aria-label]="'Upper bound of zone ' + (i + 1)"
        />
        <button type="button" class="zss-icon" [disabled]="first" (click)="moveZone(i, -1)" aria-label="Move zone up">
          <mat-icon>arrow_upward</mat-icon>
        </button>
        <button type="button" class="zss-icon" [disabled]="last" (click)="moveZone(i, 1)" aria-label="Move zone down">
          <mat-icon>arrow_downward</mat-icon>
        </button>
        <button type="button" class="zss-icon is-danger" (click)="removeZone(i)" aria-label="Remove zone">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <button type="button" class="zss-add" (click)="addZone()">
        <mat-icon>add</mat-icon> Add zone
      </button>
      <p class="zss-hint">
        Zones run from the minimum up to each "to" value, in this order. Leave the last one empty to reach the maximum.
        The badge shows the label of the zone the value falls in.
      </p>
    </div>
  </div>

  <div class="zss-group">
    <button type="button" class="zss-group-head" [class.is-open]="isOpen(group.name)" (click)="toggle(group.name)">
      <mat-icon>{{ isOpen(group.name) ? 'expand_more' : 'chevron_right' }}</mat-icon>
      <span>{{ group.name }}</span>
      <small>{{ group.controls.length }}</small>
    </button>

    <div class="zss-group-body" *ngIf="isOpen(group.name)">
      <app-design-control-renderer
        *ngFor="let control of group.controls; trackBy: trackByControlKey"
        [control]="control"
        [values]="appearance()"
        [options]="options()"
        (valueChange)="onControlChange($event)"
      ></app-design-control-renderer>

      <p class="zss-hint" *ngIf="group.name === 'Sub label'">
        Tokens: <code>{{ '{value}' }}</code> <code>{{ '{min}' }}</code> <code>{{ '{max}' }}</code>
        <code>{{ '{cost}' }}</code> <code>{{ '{pct}' }}</code> (position in range)
        <code>{{ '{margin}' }}</code> ((value − cost) ÷ value). Hidden when a token has no data.
      </p>
    </div>
  </div>
</ng-container>
